var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 27 27",
    style: {
      enableBackground: "new 0 0 27 27"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5,0.6C6.4,0.6,0.6,6.4,0.6,13.5s5.8,12.9,12.9,12.9s12.9-5.8,12.9-12.9S20.6,0.6,13.5,0.6z  M13.5,2.6c6,0,10.9,4.9,10.9,10.9s-4.9,10.9-10.9,10.9S2.6,19.5,2.6,13.5S7.5,2.6,13.5,2.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5,10.5c-1.7,0-3,1.3-3,3s1.3,3,3,3 s3-1.3,3-3S15.2,10.5,13.5,10.5z M13.5,12.5c0.6,0,1,0.4,1,1c0,0.6-0.4,1-1,1s-1-0.4-1-1C12.5,12.9,12.9,12.5,13.5,12.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5,1.5c0.5,0,0.9,0.4,1,0.9l0,0.1v2c0,0.6-0.4,1-1,1c-0.5,0-0.9-0.4-1-0.9l0-0.1v-2 C12.5,1.9,12.9,1.5,13.5,1.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5,8.5c0.5,0,0.9,0.4,1,0.9l0,0.1v2c0,0.6-0.4,1-1,1c-0.5,0-0.9-0.4-1-0.9l0-0.1v-2 C12.5,8.9,12.9,8.5,13.5,8.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5,12.5c0.6,0,1,0.4,1,1c0,0.5-0.4,0.9-0.9,1l-0.1,0h-2c-0.6,0-1-0.4-1-1 c0-0.5,0.4-0.9,0.9-1l0.1,0H24.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7,7.1c0.5-0.3,1.1-0.1,1.4,0.4c0.3,0.4,0.1,1-0.3,1.3l-0.1,0.1l-1.7,1 c-0.5,0.3-1.1,0.1-1.4-0.4c-0.3-0.4-0.1-1,0.3-1.3L21,8.1L22.7,7.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8,7.1C4.3,6.8,3.7,7,3.4,7.5c-0.3,0.4-0.1,1,0.3,1.3l0.1,0.1l1.7,1 C6,10.1,6.6,10,6.9,9.5C7.1,9,7,8.5,6.6,8.2L6.5,8.1L4.8,7.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1,3.4C8.8,2.9,8.2,2.8,7.7,3.1C7.3,3.3,7.1,3.9,7.3,4.3l0.1,0.1l1,1.7 c0.3,0.5,0.9,0.6,1.4,0.4c0.4-0.3,0.6-0.8,0.4-1.3l-0.1-0.1L9.1,3.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4,3.4c0.3-0.5,0.9-0.6,1.4-0.4c0.4,0.3,0.6,0.8,0.4,1.3l-0.1,0.1l-1,1.7 c-0.3,0.5-0.9,0.6-1.4,0.4c-0.4-0.3-0.6-0.8-0.4-1.3l0.1-0.1L18.4,3.4z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5,12.5c0.6,0,1,0.4,1,1c0,0.5-0.4,0.9-0.9,1l-0.1,0h-2c-0.6,0-1-0.4-1-1 c0-0.5,0.4-0.9,0.9-1l0.1,0H4.5z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7,19c0.6,0,1,0.4,1,1c0,0.5-0.4,0.9-0.9,1l-0.1,0L10,21c-0.6,0-1-0.4-1-1 c0-0.5,0.4-0.9,0.9-1l0.1,0L16.7,19z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsage);
export default __webpack_public_path__ + "static/media/usage.e649b317e644bb7fd5ade1450bd17eb6.svg";
export { ForwardRef as ReactComponent };